module.exports = __webpack_public_path__ + "img/apply-for-rent-th.c3bcb28.png";